import styled from 'styled-components';

export const AccordionContainer = styled.div`
  [data-component='accordion-header'] > button > span:nth-child(2) {
    overflow: hidden;

    p {
      font-weight: normal;
    }
  }
`;
